export default function ImageUploader({ model, onChange }) {

    const handleChange = function (e) {

        const file = e.target.files[0];
        if (!file) { return; }

        const reader = new FileReader();

        reader.onload = (e) => {
            const data = e.target.result;

            onChange(data);
        };

        reader.readAsDataURL(file);

    };

    return (
        <>
            <div>
                {model && <img aria-hidden alt="image" src={model}></img>}
            </div>
            <div>
                <input type="file" onChange={handleChange} accept="image/*"></input>
            </div>
        </>
    );
}